// extracted by mini-css-extract-plugin
module.exports = {"Container":"helpAndSupport_Container__3DntO","Heading":"helpAndSupport_Heading__DNV2m","SubHeading":"helpAndSupport_SubHeading__xQQ81"};